import { call, put, select } from 'redux-saga/effects';

import { resetFiles } from '@actions/savedFilingPeriod';
import {
  processStandardTemplatesFailure,
  processStandardTemplatesSuccess,
} from '@actions/standardTemplate';
import { processStandardTemplates } from '@api/standardTemplate';
import { processFilesModel } from '@models/Filing/processFilesModel';
import { history, vfileRoutes } from '@routes';
import { bulkFileDeleteSaga } from '@sagas/savedFilingPeriod/bulkFileDeleteSaga';
import { toastError } from '@store/notifications';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';

export const processStandardTemplatesSaga = function* ({ payload }) {
  try {
    const { id: filingPeriodId } = yield select(selectedFilingPeriodSelector);

    const requestData = yield call(processFilesModel, payload);
    const response = yield call(processStandardTemplates, requestData);

    if (payload.isNilReturn) yield call(bulkFileDeleteSaga, { payload });

    yield put([processStandardTemplatesSuccess(response), resetFiles()]);
    yield call(history.push, vfileRoutes.FILING_PROCESSING.make(filingPeriodId));
  } catch (error) {
    const { nonFieldErrors } = error.data || {};

    yield put([
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'Failed to process data',
          id: 'pages.upload-data.processing-error',
        },
      }),
      processStandardTemplatesFailure(error),
    ]);
  }
};
